import React, { useContext, useEffect } from "react";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-final-form";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../../_context/Store";
import Validator from "../../../../_helpers/validate.schema";
import {
    UiCol,
    UiSingleRow,
} from "../../../_uiComponents/grid-container/GridContainer";

import {
    UiInput,
} from "../../../_uiComponents/form/UiInput";

import {
    UiButton,
} from "../../../_uiComponents/form/UiButton";

import {
    validateParticipantByEmailRequest,
    validateParticipantByEmailReset,
} from "../../../../_redux/_actions";

const toBool = (v) => {
    if (typeof v === "boolean") {
        return v;
    }
    if (typeof v === "string") {
        const s = v.toLowerCase();
        if (s === "true") {
            return true;
        }
        if (s === "false") {
            return false;
        }
    }
    return undefined;
};

/** Handles API envelope, nested gateway `data`, and PascalCase properties. */
const getValidateParticipantFlags = (raw) => {
    if (!raw || typeof raw !== "object") {
        return null;
    }
    let cur = raw;
    for (let i = 0; i < 4; i++) {
        const nested = cur.data;
        if (
            nested &&
            typeof nested === "object" &&
            (toBool(nested.accountExists ?? nested.AccountExists) !== undefined ||
                toBool(nested.accountActivated ?? nested.AccountActivated) !==
                    undefined)
        ) {
            cur = nested;
        } else {
            break;
        }
    }
    const accountExists = toBool(cur.accountExists ?? cur.AccountExists);
    const accountActivated = toBool(
        cur.accountActivated ?? cur.AccountActivated,
    );
    if (
        typeof accountExists !== "boolean" ||
        typeof accountActivated !== "boolean"
    ) {
        return null;
    }
    return { accountExists, accountActivated };
};

const validateSchema = () =>
    yup.object().shape({
        email: yup
            .string()
            .required("Email is required.")
            .email("Email must be a valid email."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function AboutusForm(props) {
    const actionDispatch = useDispatch();
    const navigate = useNavigate();
    const [, contextDispatch] = useContext(Context);
    const validateParticipantByEmailData = useSelector(
        (state) => state.auth.validateParticipantByEmailData,
    );

    useEffect(() => {
        const flags = getValidateParticipantFlags(
            validateParticipantByEmailData,
        );
        if (!flags) {
            return;
        }
        if (!flags.accountExists && !flags.accountActivated) {
            contextDispatch({
                type: "MESSAGE_MODAL",
                payload: {
                    show: true,
                    children: (
                        <>
                        <p>
                           Thank you for your interest in the Renault Trade Loyalty Club. 
                           It looks like your details haven't been registered yet. 
                        </p>
                        <p>
                        Please contact your local Renault Trade Parts Dealer who
                        can help you get set up.
                        </p>
                        </>
                    ),
                },
            });
            return;
        }
        if (flags.accountExists && !flags.accountActivated) {
            contextDispatch({
                type: "MESSAGE_MODAL",
                payload: {
                    show: true,
                    children: (
                        <p>
                           Thank you for your interest, an activation email has been
                           sent to you. For any issues with activation please contact support@renaulttlc.com
                        </p>
                    ),
                },
            });
            return;
        }
        if (flags.accountExists && flags.accountActivated) {
            actionDispatch(validateParticipantByEmailReset());
            navigate("/", { replace: true });
        }
    }, [
        validateParticipantByEmailData,
        contextDispatch,
        navigate,
        actionDispatch,
    ]);

    const submit = async (values, form) => {
        actionDispatch(validateParticipantByEmailRequest({ email: values.email }));
    };

    return (
        <>
            <Form
                onSubmit={submit}
                validate={onValidate}
                render={({
                    handleSubmit,
                    hasValidationErrors,
                    valid,
                    ...rest
                }) => {
                    return (
                        <form onSubmit={validateSchema}>
                            <UiInput
                                placeholder="Enter email"
                                type="text"
                                name="email"
                            />
                            <UiSingleRow>
                                <UiCol lg="12">
                                    <UiButton
                                        className="sb-main-primary-button sb-submit-button"
                                        title="Submit"
                                        onClick={handleSubmit}
                                    />
                                </UiCol>
                            </UiSingleRow>
                        </form>
                    );
                }}
            />
        </>
    );
}
